function applyFilterReducer(currentState = [], action) {
  switch (action.type) {
    case "GET_ORDERS": {
      return action.payload;
    }
    default:
      break;
  }
  return currentState;
}

export default applyFilterReducer;
